import { render } from "./DownloadPanel.vue?vue&type=template&id=518a3c7c&scoped=true"
import script from "./DownloadPanel.vue?vue&type=script&lang=js"
export * from "./DownloadPanel.vue?vue&type=script&lang=js"

import "./DownloadPanel.scss?vue&type=style&index=0&id=518a3c7c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518a3c7c"]])

export default __exports__